import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { App } from './App.js';
import { LandingPage } from './pages/LandingPage.js';
import { Toaster } from './components/ui/toaster';
import { TooltipProvider } from './components/ui/tooltip';
import './index.css';

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const previewBypass = Boolean(import.meta.env.VITE_PREVIEW_BYPASS_SECRET);
// Real Clerk keys are 60+ chars of base64. Placeholder-length keys trigger the
// no-provider fallback below, which skips ClerkProvider so the marketing
// surface renders without a working Clerk instance.
const isRealClerkKey =
  typeof clerkKey === 'string' && /^pk_(test|live)_/.test(clerkKey) && clerkKey.length >= 40;

// Three modes:
// 1. Preview bypass — full App, no ClerkProvider. Vite has aliased
//    @clerk/clerk-react to the shim so Clerk components render inert admin
//    state. The API client sends X-Preview-Bypass to skip server Clerk too.
// 2. Real Clerk — normal signed-in flow.
// 3. Placeholder key — marketing LandingPage only (no routing to auth-gated
//    pages). Unchanged behavior.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TooltipProvider delayDuration={200}>
      {previewBypass ? (
        <BrowserRouter>
          <App />
        </BrowserRouter>
      ) : isRealClerkKey ? (
        <ClerkProvider publishableKey={clerkKey} afterSignOutUrl="/">
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ClerkProvider>
      ) : (
        <BrowserRouter>
          <LandingPage />
        </BrowserRouter>
      )}
      <Toaster />
    </TooltipProvider>
  </StrictMode>,
);
